import { FETCH_UNAVAILABILITIES } from "../../actions/types";

const INITIAL_STATE = {
  unavailabilities: []
};

const unavailabilitiesReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_UNAVAILABILITIES:
      return payload.data.unavailabilities;
    default:
      return state;
  }
};

export default unavailabilitiesReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/unavailabilities_reducer.js